import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PoweredByBrand from '../../../../common/powered-by-brand';
/**
 * Footer component that renders localized powered-by branding.
 *
 * @returns {JSX.Element} The rendered footer branding.
 */
export default function Footer() {
    return _jsx(PoweredByBrand, {});
}
